import React, { FC } from 'react';
import { toast } from 'react-toastify';
import { Button, Card, CardBody, CardFooter, CardHeader } from 'reactstrap';
import { InlineHelp, PermissionBoundary } from '../../../../components';
import { useTranslation } from '../../../../translations';
import { Fetcher, useBoolState, useFetcher } from '../../../../utils';
import { AssignCategorySurchargeModal } from './assignCategorySurchargeModal';
import { CategorySurchargeItem } from './categorySurchargeItem';

interface Props {
  readonly categoryId: number;
}

export const CategorySurcharges: FC<Props> = ({ categoryId }) => {
  const { ts } = useTranslation();
  const [openModal, enableModal, disableModal] = useBoolState(false);
  const fetcher = useFetcher(async () => await api.getCategorySurcharges(categoryId), [categoryId]);

  if (!fetcher.success) {
    return <Fetcher result={fetcher} />;
  }

  return (
    <Card className="mb-10">
      <CardHeader>
        {ts('surcharges.category')}
        <InlineHelp>
          <p>{ts('surcharges_added_at_the_category')}</p>
          <p>{ts('if_you_remove_a_surcharge')}</p>
        </InlineHelp>
      </CardHeader>
      <CardBody>
        {fetcher.data.length === 0 ? (
          <i>{ts('there_are_no_category_level')}</i>
        ) : (
          fetcher.data.map((surcharge) => (
            <CategorySurchargeItem
              categoryId={categoryId}
              key={surcharge.id}
              refresh={fetcher.refresh}
              surcharge={surcharge}
            />
          ))
        )}
      </CardBody>
      <CardFooter>
        <PermissionBoundary
          inline
          requiredPermissions={['product:category:manage', 'product:manage']}
        >
          <Button color="primary" onClick={enableModal} outline>
            {ts('assign_category_level_surcharge')}
          </Button>
          <AssignCategorySurchargeModal
            categoryId={categoryId}
            onCancel={disableModal}
            onUpdate={() => {
              toast.success(ts('successfully_assigned_new_category_level'));
              disableModal();
              fetcher.refresh();
            }}
            open={openModal}
          />
        </PermissionBoundary>
      </CardFooter>
    </Card>
  );
};
